import { observable } from 'mobx';
import qs from 'querystring';
import createRouteKey from './createRouteKey';
export default function createRoute(node, parentUrl, segment, params, query) {
  var url = '' + parentUrl + segment;
  var key = createRouteKey(node, url);
  return observable({
    node: node,
    key: key,
    value: url + '?' + qs.stringify(query),
    parentUrl: parentUrl,
    segment: segment,
    params: params,
    query: query,
    context: observable.ref(node.value.getContext()),
    data: node.value.getData(),
    onTransition: node.value.onTransition
  });
}